export const title = 'Principales insectos que impactan en el establecimiento del cultivo';

export const featuresNotes = [
    {
        id: 1,
        name: 'Chinches (Dichelops)',
        type: '',
        moment: 'Mayor daño entre VE y V4. Los síntomas se exprsan claramnte en V6',
        symptoms: [],
        damage: [
            'Al momento de alimentarse, el insecto inyecta toxinas que producen el crecimiento anormal de las plantas y necrosis.',
            'Una planta afectada por Chinches puede perder entre el 30 y el 100% del Rendimiento.',
        ],
        cultives: 'Maíz.',
        conditions: [],
        control: 'Neonicotinoides, Piretroides',
        images: ['bug-1'],
        color: 'green',
        side: 'ltr',
    },
    {
        id: 2,
        name: 'Gusanos Blancos (Dilobobderus abderus; Cyclocephala spp.; Colaspis spp.)',
        type: '',
        moment: 'De VE a V4',
        symptoms: [],
        damage: [
            'Adultos emergentes del invierno se alimentan de las raíces y plántulas causando la muerte de las mismas.',
            'Perdida de stand de plantas, más agravante en sistemas de siembra directa.',
            'Con alta infestación la reducción del stand puede pasar del 5 al 17%.',
        ],
        cultives: 'Varios incluidos Soja y Maíz.',
        conditions: [''],
        control: 'Neonicotinoides, Piretroides, Carbamatos',
        images: ['bug-2'],
        color: 'light-green',
        side: 'rtl',
    },
    {
        id: 3,
        name: 'Gusanos Alambre (Dyscinetus gagates; Conoderus spp.; Agriotes spp)',
        type: '',
        moment: 'VE a V4',
        symptoms: [],
        damage: [
            'Se alimentan de semilla y plántulas. Desentierra la semilla o entierra la plántula, resultado en muerte, achaparramiento o deformación.',
            'En maíz se pueden presentar las hojas externas activas mientras que las internas muertas.',
            'Los adultos se alimentan de huevos, pasturas y granos pequeños.',
        ],
        cultives: 'Puede afectar varios cultivos.',
        conditions: [],
        control: 'Neonicotinoides, Carbamatos',
        images: ['bug-3'],
        color: 'dark-green',
        side: 'ltr',
    },
    {
        id: 4,
        name: 'Orugas Cortadoras (Agrotis y Feltia)',
        type: '',
        moment: 'Tienen varios estadios larvales estando presentes en los cultivos de Agosto a Noviembre',
        symptoms: [],
        damage: [
            'Se alimentan de varios cultivos incluidas malezas. La siembra directa y la humedad favorecen su ataque.',
            'Las larvas cortan y barrenan el cultivo de soja y maíz. Se ven inicialmente manchones.',
            '1 oruga puede dañar de 2 a 10 plantas.',
        ],
        cultives: 'Varios incluidos Soja y Maíz.',
        conditions: [],
        control: 'Neonicotinoides, Piretroides, Carbamatos',
        images: ['bug-4'],
        color: 'light-brown',
        side: 'rtl',
    },
];
